<template lang="pug">
.pagination__container
  .pagination__pages
    .pagination__button(
      v-for="page in visiblePages"
      :key="page.key || page.value"
      :class="{ active: currentPage === page.value }"
      @click="currentPage = page.value"
    ) {{ page.isSpread ? '...' : page.value }}
  .pagination__controls
    .pagination__button.pagination__button--arrow(
      :disabled="currentPage <= 1"
      @click="currentPage--"
    )
      v-icon.rotate-90(size="16") $ichevron-down
    .pagination__button.pagination__button--arrow(
      :disabled="currentPage >= length"
      @click="currentPage++"
    )
      v-icon.rotate-270(size="16") $ichevron-down
</template>

<script>
const MAX_PAGES_BUTTONS = 7;

const formatPageValues = (pages) => {
  if (!Array.isArray(pages)) {
    const result = [];
    for (let i = 1; i <= pages; i++) {
      const preparedPage = { value: i };
      result.push(preparedPage);
    }
    return result;
  }
  return pages.map((value) => ({ value }));
};

export default {
  name: 'AppPaginationControls',

  props: {
    value: {
      type: [Number, String],
      default: 1,
    },
    length: {
      type: [Number, String],
      default: 1,
    },
  },

  computed: {
    currentPage: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },

    visiblePages() {
      const { length, currentPage, getArraysMedianValue } = this;
      if (length <= MAX_PAGES_BUTTONS) {
        return formatPageValues(length);
      }
      if (currentPage < 3 || currentPage >= length - 2) {
        const first = formatPageValues(3);
        const last = formatPageValues([length - 2, length - 1, length]);
        const spread = {
          key: 'spread',
          value: getArraysMedianValue(first, last),
          isSpread: true,
        };
        return [...first, spread, ...last];
      }
      const first = formatPageValues(1);
      const last = { value: length };
      const middle = formatPageValues([currentPage - 1, currentPage, currentPage + 1]);
      const spreadLeft = {
        key: 'spread_l',
        value: getArraysMedianValue(first, middle),
        isSpread: true,
      };
      const spreadRight = {
        key: 'spread_2',
        value: getArraysMedianValue(middle, [last]),
        isSpread: true,
      };
      return [...first, spreadLeft, ...middle, spreadRight, last];
    },
  },

  methods: {
    getArraysMedianValue(firstArray = [], lastArray = []) {
      const lastOfFirstArray = [...firstArray].pop();
      const [firstOfLastArray] = lastArray;
      const first = Number(lastOfFirstArray?.value || 0);
      const last = Number(firstOfLastArray?.value || 0);
      return Math.trunc((first + last) / 2);
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  &__container {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  &__button {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    line-height: 18px;
    width: 28px;
    height: 40px;
    border: 1px solid #{$redesignBackground};
    border-radius: 8px;
    background: #{$redesignBackground};
    color: #{$redesignBlack};
    transition: all 0.1s !important;
    cursor: pointer;

    &:disabled,
    &[disabled] {
      background: #{$redesignControlsBackgroundAlternative} !important;
      pointer-events: none;
      & .v-icon {
        color: #{$redesignDisabledText} !important;
      }
    }
    &:hover,
    &.active {
      color: #{$redesignPrimaryDarken};
      border-color: #{$redesignPrimary};
      font-weight: 500;
    }
    &--arrow {
      width: 40px !important;
      height: 40px !important;
      border-radius: 12px !important;
    }
  }

  &__pages {
    display: flex;
    gap: 8px;
  }

  &__controls {
    display: flex;
    gap: 12px;
  }
}
</style>
